function isMobile() {
  return window.matchMedia('(max-width: 767px)').matches;
}

export default isMobile;
